export default "__VITE_ASSET__DgdJVe4z__"